import { useEffect, useRef } from 'react';
import { X, Zap } from 'lucide-react';

interface Props {
  newLevel: number;
  onClose: () => void;
}

export default function LevelUpModal({ newLevel, onClose }: Props) {
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const t = setTimeout(() => onClose(), 6000);
    closeRef.current?.focus();
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="relative bg-white dark:bg-zinc-900 rounded-3xl shadow-2xl overflow-hidden w-full max-w-sm text-center p-8">
        {/* Confetti-style gradient top strip */}
        <div className="absolute top-0 inset-x-0 h-2 bg-gradient-to-r from-brand-400 via-violet-500 to-brand-600" />

        <button
          ref={closeRef}
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 dark:text-zinc-500 hover:text-gray-600 dark:hover:text-zinc-400 dark:text-zinc-400"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="flex items-center justify-center w-24 h-24 mx-auto mb-4 rounded-full bg-gradient-to-br from-brand-500 to-brand-700 shadow-lg dark:shadow-black/40">
          <Zap className="h-10 w-10 text-white" />
        </div>

        <p className="text-xs font-semibold text-brand-600 dark:text-brand-400 uppercase tracking-widest mb-1">Level Up!</p>
        <p className="text-5xl font-black text-gray-900 dark:text-zinc-100 mb-2">{newLevel}</p>
        <p className="text-gray-500 dark:text-zinc-500 text-sm">
          You've reached <strong>Level {newLevel}</strong>. Keep collecting, trading, and building decks!
        </p>

        <button
          onClick={onClose}
          className="mt-6 w-full btn-primary py-2.5"
        >
          Awesome!
        </button>
      </div>
    </div>
  );
}
